import { Component, ChangeDetectionStrategy } from '@angular/core';

import { ModalState, ModalSettingsJsonViewer } from './generic-modal.service';

import { BizJsonViewerComponent } from '../json-viewer/json-viewer.component';

@Component({
    selector: 'ep-modal-json-viewer',
    templateUrl: './modal-json-viewer.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [BizJsonViewerComponent]
})
export class ModalJsonViewerComponent {
    options: ModalSettingsJsonViewer;

    constructor(private modalState: ModalState) {
        this.options = modalState.options as ModalSettingsJsonViewer;
    }

    close() {
        this.modalState.modal.dismiss();
    }

    ok() {
        this.modalState.modal.close();
    }
}